import type { JSX } from 'react';

import Link from 'pkg/router/Link';

import { addFormatter } from 'components/formatted-content/FormattedContent';

addFormatter('emails', {
	defaultIgnored: true,
	selector: /([a-zA-Z0-9._+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})/gi,
	decorator: (guid: string, match: string): JSX.Element => {
		return (
			<Link key={guid} href={`mailto:${match}`}>
				{match}
			</Link>
		);
	},
});
